export default __webpack_public_path__ + "static/media/PTSerif-Bold.baec85e6.ttf";